const ready = require("%helpers%/document-ready.js");

ready(function() {

	const $priceItems = $(".prices__wrap-item");
	const $priceItemsBtns = $(".prices__item-btn-control");

	// -- Functions BEGIN
	const changeBtnText = ($btn) => {
		const $btnTextTag = $btn.find(".btn__text");
		const textStates = {
			show: $btnTextTag.data("text-show").trim(),
			hide: $btnTextTag.data("text-hide").trim()
		};
		const curText = $btnTextTag.text().trim();

		if ( curText == textStates.show ) {
			$btnTextTag.text(textStates.hide);
		}
		else if ( curText == textStates.hide ) {
			$btnTextTag.text(textStates.show);
		}
	};

	const toggleItemText = ($btn) => {
		const $curItem = $btn.closest(".prices__item");
		const $text = $curItem.find(".prices__item-wrap-text");
		$text.slideToggle(1000);
	};

	const setEventOnBtns = () => {
		$priceItemsBtns.on("click", function () {
			$(this).toggleClass("btn_transparent_active");
			changeBtnText($(this));
			toggleItemText($(this));
			$(this).closest(".prices__wrap-item").toggleClass("prices__wrap-item_active");
		});
	};
	// -- Functions END

	if ($priceItems.length && $priceItemsBtns.length) setEventOnBtns();

});
